import { render, staticRenderFns } from "./ProblemasSinal.vue?vue&type=template&id=1643145c&scoped=true&"
import script from "./ProblemasSinal.vue?vue&type=script&lang=js&"
export * from "./ProblemasSinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643145c",
  null
  
)

export default component.exports